import {useFormik} from "formik";
import * as Yup from "yup";
import {useParams} from "react-router-dom";
import ModalTemplate from "../../ModalTemplate/ModalTemplate";
import {documentIcon} from "../../Icon/Icon";
import Input from "../../Input/Input";
import Button from "../../Button/Button";

const validationSchema = Yup.object({name: Yup.string().required('Name is required')});

const CreateCheckpointModal = ({onSave, onClose}) => {
    const {id} = useParams();

    const formik = useFormik({
        initialValues: {
            name: ""
        },
        validationSchema,
        onSubmit: (values) => {
            const data =  {name: values.name, document: {id}};

            onSave(data);
            onClose();
        }
    })

    return (
        <ModalTemplate
            title="Add name for the CheckPoint"
            onClose={onClose}
            icon={documentIcon}
            footerActions={
                <>
                    <Button
                        onClick={formik.handleSubmit}
                    >
                        Save
                    </Button>
                    <Button
                        onClick={onClose}
                        variant="secondary"
                    >
                        Cancel
                    </Button>
                </>
            }
        >
            <Input
                name="name"
                label="Name"
                className="modal"
                formik={formik}
            />
        </ModalTemplate>
    )
}

export default CreateCheckpointModal